module.exports = __webpack_public_path__ + "static/media/4.da5485ea.jpg";